import {ConfirmButton, CancelButton} from '@hconnect/uikit/src/lib2'
import {Box, TextField} from '@mui/material'
import {TFunction} from 'i18next'
import React, {useState} from 'react'

import {MAX_COMMENT_LENGTH} from './comments.consts'

interface CommentsFormProps {
  onCancel: () => void
  onSave: (value: string) => void
  translate: TFunction
}

export const CommentForm: React.FC<CommentsFormProps> = ({onCancel, onSave, translate}) => {
  const [commentValue, setCommentValue] = useState('')

  return (
    <Box display={'flex'} flexDirection={'column'} pt={1} pb={2}>
      <TextField
        variant={'filled'}
        label={translate('comments.label.enterComment')}
        multiline
        value={commentValue}
        inputProps={{
          maxLength: MAX_COMMENT_LENGTH,
          'data-test-id': 'comment-form-comment-field-input'
        }}
        onChange={(event) => {
          setCommentValue(event.target.value)
        }}
        data-test-id={'comment-form-comment-field'}
      />
      <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} pt={1.5}>
        <CancelButton
          variant="outlined"
          onClick={onCancel}
          data-test-id="comment-cancel-btn"
          sx={{mr: 1.5}}
        >
          {translate('button.cancel')}
        </CancelButton>
        <ConfirmButton
          onClick={() => {
            onSave(commentValue.trim())
          }}
          disabled={!commentValue.trim()}
          data-test-id="comment-save-btn"
        >
          {translate('button.save')}
        </ConfirmButton>
      </Box>
    </Box>
  )
}
